// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Header":"Header-n8cunex7fcgav5qnymew7dqyxg97a6nk96zecvgc1rewxyy86q23dwws1zq7t4kve3hh38zg59xt6jqayn6ycqenu27am39rjr91wn","ButtonWrapper":"ButtonWrapper-215ph78grrr3s86hwu8a1fr387afhqks5kqd7bwrhj3p8wanv6nt5r5jcrpkp5pdabnqwh18bqngcmk4zgr247kfrcq1pqzpjrgb2zp","loading":"loading-2pxutb398rxdbasakkddbj1zjh8y6p266e3h1u89nfp5r9z2hzemh5abfbsr66uhh3xtdu6nutpnd3r9vrqff97hnxs8qfagccx4q6y","pulse":"pulse-ddge5a6q2sjy8qb58mfr11j389j1y4x9w6aptapsp64vmp2d56ftr3rbkkp3rrtv3tcf17qjffcr3whd69yx46n6f2q5ysrgf2p2w3"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/UpcomingEvents/UpcomingEvents.module.scss
// module id = 1662
// module chunks = 0